/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Add_SessionInputs */

const en_plan_add_session = /** @type {(inputs: Plan_Add_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add cook session`)
};

const de_plan_add_session = /** @type {(inputs: Plan_Add_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kochsession hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add cook session" |
*
* @param {Plan_Add_SessionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_add_session = /** @type {((inputs?: Plan_Add_SessionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Add_SessionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_plan_add_session(inputs)
	return en_plan_add_session(inputs)
});